export const geolocationPermissionGranted = async (): Promise<boolean> => {
  try {
    const permission = await navigator.permissions.query({ name: 'geolocation' });
    return permission.state === 'granted';
  } catch {
    return false;
  }
};
